export default {
  state: {
    cookiesAccepted: false
  },

  mutations: {
    SET_COOKIES_ACCEPTED (state, accepted) {
      state.cookiesAccepted = accepted
    }
  },

  actions: {
    setCookiesAccepted ({ commit }, accepted) {
      commit('SET_COOKIES_ACCEPTED', accepted)
    }
  },

  getters: {
    cookiesAccepted (state) { return state.cookiesAccepted }
  }
}



// WEBPACK FOOTER //
// ./src/stores/cookies.js